import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const TicketsIcon: FC<IconProps> = ({ width = 20, height = 24, ...rest }) => (
  <Icon type="Tickets" width={width} height={height} alt="Tickets" {...rest} />
)
